import {Component, computed, input, output} from '@angular/core';
import {IconType} from '../../icon/icon';
import {mapIconTypeToPrimeIcon} from '../../icon/icon.mapper';

@Component({
  selector: 'elcia-ai-button',
  imports: [],
  templateUrl: './ai-button.html',
  styleUrl: './ai-button.scss'
})
export class AiButton {
  label = input<string>();
  icon = input<IconType>('AI');
  disabled = input(false);
  isLoading = input(false);
  onClick = output<MouseEvent>();

  protected primeIcon = computed(() => {
    const icon = mapIconTypeToPrimeIcon(this.icon());
    return icon ? `pi ${icon}` : '';
  });

  protected onClicked(event: MouseEvent) {
    this.onClick.emit(event);
  }
}
